import React from "react";
import { IconBaseProps } from "react-icons";

export const Forward30SVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    display="block"
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill={fill}
    fillRule="evenodd"
  >
    <path d="M27.885 11.045l-1.381.604c.455 1.294.685 2.666.685 4.071 0 6.729-5.532 12.2-12.351 12.2-6.827 0-12.311-5.438-12.311-12.2 0-6.749 5.512-12.16 12.351-12.16H16v1.317L19.633 2.8 16 .723V2.08h-1.122C7.224 2.08 1 8.21 1 15.76 1 23.302 7.215 29.4 14.878 29.4c7.655 0 13.879-6.13 13.879-13.68 0-1.568-.3-3.148-.872-4.675z" />
    <path d="M11.095 15.848v-1.191h.703c.561 0 .928-.337.928-.801-.005-.43-.376-.757-.914-.757-.59 0-.913.425-.927.825h-1.5c.045-1.186.933-2.026 2.491-2.026 1.372 0 2.407.713 2.417 1.748.01.947-.698 1.42-1.201 1.49v.067c.644.044 1.391.547 1.401 1.602.01 1.24-1.25 1.997-2.68 1.997-1.71 0-2.505-.967-2.52-2.056h1.475c.034.479.459.83 1.084.83.644 0 1.04-.375 1.035-.874 0-.473-.371-.854-1.055-.854h-.737zm5.644-.713v.415c0 1.328.41 1.963 1.02 1.963.606 0 1.021-.645 1.021-1.963v-.415c0-1.318-.415-1.948-1.02-1.948-.61 0-1.02.62-1.02 1.948zm-1.616.42v-.425c0-1.924.967-3.232 2.651-3.232 1.7 0 2.618 1.294 2.618 3.232v.425c0 1.802-.874 3.247-2.652 3.247-1.694 0-2.617-1.323-2.617-3.247z" />
  </svg>
);
